<template>
  <v-row class="fill-height">
    <v-col>
      <div class="tcdc-exhibition-card-border-green fill-height">
        <v-img :src="image" aspect-ratio="1.7"></v-img>
        <v-row align="stretch">
          <v-col>
            <span class="text-uppercase text-tcdc-green sub-header1 bold">
              {{title}}
            </span>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col class="d-flex flex-1 align-center">
            <span class="text-tcdc-grey1 bold mr-4">{{date}}</span>
            <img src="../../assets/icons/generals/view.png" class="tcdc-view-icon mr-2" />
            <span class="text-tcdc-grey1 bold">{{formatNumber(viewer)}}</span>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </v-row>
</template>

<script>
// import Divider from "../../components/dividers/Divider";
export default {
  props: {
    image: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    date: {
      type: String,
      default: ""
    },
    viewer: {
      type: Number,
      default: null
    }
  },
  components: {
    // Divider
  },
  methods: {
    formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
};
</script>

<style lang="scss" scoped>
.eventcard-logo {
  height: 25px;
  object-fit: contain;
}
.tcdc-exhibition-card-border-green {
  border-bottom: 2px solid $tcdcGreen;
}
</style>
